/**
 * Authentication Routes
 * ============================================================================
 *
 * Purpose:
 * --------
 * Defines authentication-related routes.
 * ============================================================================
 */

import { lazy } from 'react';
import { LAYOUT_TYPES, ROUTE_PATHS } from 'navigation/constants';
import type { RouteGroup } from 'navigation/types';

const LoginPage = lazy(() =>
  import('features/auth/ui/login').then((m) => ({ default: m.LoginPage }))
);
const BusinessRegistrationPage = lazy(() =>
  import('features/onboarding/ui/business-registration').then((m) => ({
    default: m.BusinessRegistrationPage,
  }))
);
const OtpPage = lazy(() =>
  import('features/auth/ui/otp').then((m) => ({ default: m.OtpPage }))
);
const ForgotPasswordPage = lazy(() =>
  import('features/auth/ui/forgot-password').then((m) => ({ default: m.ForgotPasswordPage }))
);
const ResetPasswordPage = lazy(() =>
  import('features/auth/ui/reset-password').then((m) => ({ default: m.ResetPasswordPage }))
);
const AcceptInvitationPage = lazy(() =>
  import('features/auth/ui/accept-invitation').then((m) => ({ default: m.AcceptInvitationPage }))
);

export const authRoutes: RouteGroup = {
  name: 'auth',
  layout: LAYOUT_TYPES.AUTH,
  routes: [
    {
      path: ROUTE_PATHS.LOGIN,
      component: LoginPage,
      meta: {
        title: 'auth:login.title',
        description: 'Login to your Bimanova account',
      },
    },
    {
      path: ROUTE_PATHS.REGISTER,
      component: BusinessRegistrationPage,
      meta: {
        title: 'auth:register.title',
        description: 'Register your business with Bimanova',
      },
    },
    {
      path: ROUTE_PATHS.VERIFY_OTP,
      component: OtpPage,
      meta: {
        title: 'auth:otp.title',
        description: 'Verify your email address',
      },
    },
    {
      path: ROUTE_PATHS.FORGOT_PASSWORD,
      component: ForgotPasswordPage,
      meta: {
        title: 'auth:forgotPassword.title',
      },
    },
    {
      path: ROUTE_PATHS.RESET_PASSWORD,
      component: ResetPasswordPage,
      meta: {
        title: 'auth:resetPassword.title',
      },
    },
    {
      path: ROUTE_PATHS.ACCEPT_INVITATION,
      component: AcceptInvitationPage,
      meta: {
        title: 'auth:acceptInvitation.title',
      },
    },
  ],
};
